import React, {useEffect, useState} from 'react';
import ClientJobHeader from './ClientJobHeader';
import '../../styles/components/MarketPlace/AppliedJobCard.scss';
import { Routes } from '../../constants/RouterConstants';
import {Navigation} from '../../services/NavigationService';
import { getJobApplicationStatusByApplicationId } from '../../services/API/MarketplaceService';
import { CheckCircleFilled, ExclamationCircleFilled } from '@ant-design/icons';
import {Divider, Typography, Timeline, Button, Card} from 'antd';
import useMoengage from '../../hooks/useMoengage';
import moment from 'moment';
import { useMitraStore, useMitraDispatch } from '../../contexts/MitraContext';
import TimelineSkeleton from './skeletons/TimelineSkeleton';

const { Text } = Typography;

function AppliedJobsCard({jobData, city}) {
    const [applicationStatusSummary, setApplicationStatusSummary] = useState([]);
    const [, trackEvent] = useMoengage();
    const { selectedMitraDetails } = useMitraStore();
    const { actions: MitraActions } = useMitraDispatch();
    const { setSelectedJobDescription } = MitraActions;
    const viewApplicationStatus = () => {
    setSelectedJobDescription(jobData.jobDetails);
    trackEvent('jse_clicked_track_on_applied_job', 
    { 
        userId: localStorage.getItem('userId'), 
        jobId: jobData.id, companyName: jobData.companyName, 
        userPhoneNumber: selectedMitraDetails?.userPhoneNumber, 
        timeStamp: moment().format('MM/DD/YYYY HH:mm:ss'),
    });
    const route = {
        pathname: Routes.APPLICATION_STATUS,
        search: `applicationId=${jobData.scheduledInterviewId}&city=${localStorage.getItem("preferredLocation")}`
    };
    Navigation.push(route);
    };

    const preprocessData = (timeLineDetails) => {
    let actualDataToShow = [];
    const processedTimelineDetails = [...timeLineDetails];
    let prevMilestoneAchieved = false;
    const totalTimelineItems = processedTimelineDetails.length;

    for(let i=0; i<totalTimelineItems; i++) {
        // if previous milestone is achieved, then current milestone is set as current objective
        // done to achieve css for current milestone as well as to hide action buttons of other pending milestones
        if (prevMilestoneAchieved) {
        processedTimelineDetails[i].currentObjective = true;
        actualDataToShow.push(processedTimelineDetails[i]);
        prevMilestoneAchieved = false;  // turning it false as current milestone is detected
        } else {
        processedTimelineDetails[i].currentObjective = false;
        }

        // if current milestone is marked as completed, then turning the 'prevMilestoneAchieved' flag to true
        if (processedTimelineDetails[i].isCompleted) {
        prevMilestoneAchieved = true;
        actualDataToShow = []; // picking only latest completed and nex pending in case of multiple such cases
        actualDataToShow.push(processedTimelineDetails[i]);
        }
    }

    setApplicationStatusSummary([...actualDataToShow]);
    };
    
    useEffect(() => {
    getJobApplicationStatusByApplicationId(jobData.scheduledInterviewId)
    .then(response => {
        // console.log(response.data.timelineDetails);
        preprocessData(response.data.timelineDetails);
    })
    .catch(err => console.log(err));
    }, [jobData])
      

  return (
        <div>
            <Card
            style={{margin: '0px 16px 8px', borderRadius:'8px'}}
            bodyStyle={{padding:'8px', display:'flex',flexDirection:'column',gap:'1em',width: '306px'}}>
                <ClientJobHeader jobData={jobData} callback={()=>viewApplicationStatus()}/>
                <div className='applied-job-body' onClick={()=>viewApplicationStatus()}>
                    {/* <img src='/images/app-status.png' /> */}
                    <div className='application-status-summary-container'>
                    <Timeline>
                        {applicationStatusSummary.length
                        ? applicationStatusSummary.map(item => {
                            return (
                                <Timeline.Item
                                key={item.id}
                                dot={
                                    item.isCompleted ? <CheckCircleFilled style={{ color: '#27A745' }} /> : ''
                                }
                                >
                                <div className="item-container">
                                    <Text className="status-header">
                                    {item.header}
                                    {item.status === 'pending' && item.currentObjective ? (
                                        <Text className="pending-txt">Pending</Text>
                                    ) : (
                                        ''
                                    )}
                                    </Text>

                                </div>
                                </Timeline.Item>
                            );
                            })
                        : <TimelineSkeleton />}
                    </Timeline>
                    </div>
                    <Button className="apply-now" onClick={()=>viewApplicationStatus()}>Track</Button>
                </div>
            </Card>
            </div>
        
  )
}

export default AppliedJobsCard
